module.exports = __webpack_public_path__ + "img/forth.de345aa3.png";